import React, {Component} from 'react'
import Barcode from './data/Barcode'
import LabelPreview from './data/LabelPreview'
import TrackingCarrier from './data/TrackingCarrier'
import TrackingNumber from './data/TrackingNumber'
import CreatedDate from './data/CreatedDate'
import LabelType from './data/LabelType'
import PropTypes from 'prop-types'
import LabelNote from './data/LabelNote'
import LabelActions from './data/LabelActions'

class LabelItem extends Component {
    render() {
        const {label, onFetchLabels} = this.props
        const {barcode, created_at, printable_url, tracking_carrier, tracking_number, type, note, _id, sync_to_fac_status, sync_to_fac_error_message} = label

        return (
            <tr className='LabelItem'>
                <Barcode barcode={barcode}/>
                <LabelPreview printableUrl={printable_url}/>
                <TrackingCarrier trackingCarrier={tracking_carrier}/>
                <TrackingNumber
                    trackingNumber={tracking_number}
                    syncStatus={sync_to_fac_status}
                    syncErrMessage={sync_to_fac_error_message}
                />
                <CreatedDate created={created_at}/>
                <LabelNote note={note} labelId={_id}/>
                <LabelType type={type}/>
                <LabelActions label={label} labelId={_id} barcode={barcode} onFetchLabels={onFetchLabels}/>
            </tr>
        )
    }
}

LabelItem.propTypes = {
    label: PropTypes.object.isRequired,
    onFetchLabels: PropTypes.func.isRequired,
}

export default LabelItem
